import Alpine from "alpinejs";
import { Account } from "../Account";
import { AddPromoProductToCart } from "../AddPromoProductToCart";
import { GiftProduct } from "../GiftProduct";
import { MobileProductSection } from "../MobileProductSection";
import { Modal } from "../Modal";
import { BundleProduct } from "../BundleProduct";
import { PaginatedBlog } from "../PaginatedBlog";
import { RecipesPage } from "../RecipesPage";
import { Slider } from "../Slider";
import { Product } from "../Product";
import { PromoProduct } from "../PromoProduct";
import { ProductSelect } from "../ProductSelect";
import { ThumbSlider } from "../ThumbSlider";
import { ThumbSliderPromo } from "../ThumbSliderPromo";
import { YoutubePlaylist } from "../YoutubePlaylist";

window.Alpine = Alpine;

Alpine.data("Account", Account);
Alpine.data("AddPromoProductToCart", AddPromoProductToCart);
Alpine.data("MobileProductSection", MobileProductSection);
Alpine.data("Modal", Modal);
Alpine.data("PaginatedBlog", PaginatedBlog);
Alpine.data("BundleProduct", BundleProduct);
Alpine.data("GiftProduct", GiftProduct);
Alpine.data("PaginatedBlog", PaginatedBlog);
Alpine.data("PromoProduct", PromoProduct);
Alpine.data("Product", Product);
Alpine.data("ProductSelect", ProductSelect);
Alpine.data("RecipesPage", RecipesPage);
Alpine.data("Slider", Slider);
Alpine.data("ThumbSlider", ThumbSlider);
Alpine.data("ThumbSliderPromo", ThumbSliderPromo);
Alpine.data("YoutubePlaylist", YoutubePlaylist);

Alpine.store("modal", {
  activeModalIds: [],

  openModal(modalId) {
    if (this.activeModalIds.includes(modalId)) {
      return;
    }

    this.activeModalIds.push(modalId)
    window.dispatchEvent(
      new CustomEvent("modal:open", { bubbles: true, detail: { modalId } }),
    );
    document.body.style.overflow = "hidden";
  },

  closeModal(modalId) {
    if (!this.activeModalIds.includes(modalId)) {
      return;
    }

    this.activeModalIds.splice(this.activeModalIds.indexOf(modalId), 1);
    window.dispatchEvent(
      new CustomEvent("modal:close", { bubbles: true, detail: { modalId } }),
    );
    document.body.style.overflow = "auto";
  }
})

Alpine.start();
